/* global valideraTelefonnummer */

$.validator.unobtrusive.adapters.addBool('telefonnummer');
$.validator.addMethod('telefonnummer',
    function (value) {
        if (value === null || value.length === 0) {
            return true;
        }

        return valideraTelefonnummer(value);
    }
);

window.valideraTelefonnummer = function (value) {
    value = $.trim(value);
    value = value.replace(/\s+/g, '');

    var match = false;

    var innehallerEttBindestreckRegex = value.match(/(^[+]{0,1}[0-9]+[-]{1}[0-9]+$)/);
    if (innehallerEttBindestreckRegex) {
        value = value.replace('-', '');
        match = value.match(/(^[+]{0,1}[0-9]{9,12}|^[0-9]{8,13})$/);
    } else {
        match = value.match(/(^[+]{0,1}[0-9]{8,13}|^[0-9]{7,14})$/);
    }

    return match;
};